import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Button, Grid, Loader, Header, Segment, Icon, Popup} from 'semantic-ui-react';
import _ from 'lodash';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {createRolePermissionsBox} from './utils';
import {retrieveRolesFromPermissions, orgRoles, displayPhoneNumber} from 'common/utils';
import {SARROLES, AOR_SAR_ROLES} from './constants';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import OrgUserManageForm from './orgUserManageForm';
import {Alert} from 'componentLibrary';

export class orgUsersCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: this.props.userData,
      error: '',
      lastAORS: [{}],
      loading: true,
      subOrgToggle: this.props.subOrgToggle,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.userData !== prevProps.userData) {
      let userData = this.props.userData;
      if (this.props.renderType == 'subOrg') {
        const filteredUsers = _.filter(userData, (user) => {
          return _.includes(user.entityId, this.props.parentOrgId);
        });
        userData = filteredUsers;
      }
      this.setState({
        users: userData,
      });
    }
  }

  componentDidMount() {
    this.setState({
      users: this.props.userData,
    });
  }
  UNSAFE_componentWillReceiveProps(props, state) {
    const userData = _.get(props, 'userData', []);
    if (userData.length > 0) {
      this.setState({
        lastAORs: this.fetchAllLastAOR(props.userData, props.entities),
        loading: false,
      });
    }
  }

  handleRemoveClick = async (selectedUser) => {
    try {
      let res = await this.props.removeUnregisteredUser(selectedUser);
      if (res.complete) {
        this.props.toggleModal('remove');
        this.props.toggleModal('showConfirmation');
      }
    } catch (e) {
      this.setState({
        error: 'Failed to process your request',
      });
    }
  };

  renderRemoveConfirmation = (userId) => {
    return (
      <FemaGoModal
        title="Unregistered user has been removed"
        size="medium"
        closeOnDimmerClick="no"
        open={this.props.showRemoveConfirmation}
        buttonText="Close window"
        confirmAction={() => {
          this.props.toggleModal('showConfirmation');
          this.props.reloadUserList();
        }}
        cancelAction={() => {
          this.props.toggleModal('showConfirmation');
          this.props.reloadUserList();
        }}
      >
        <Alert
          size="medium"
          header={'The pending registration has been removed'}
          paragraph={false}
          type="info"
          confirmButton="hidden"
        >
          <div id="team-notification">
            <h5>{userId}</h5>
          </div>
        </Alert>
      </FemaGoModal>
    );
  };

  prioritizePhoneList = (user) => {
    var order = ['W', 'M', 'H', 'O', 'X'];
    if (!_.isEmpty(user.phoneNumbers)) {
      for (var i = 0; i < order.length; i++) {
        var phone = _.find(user.phoneNumbers, {phoneNumberType: order[i]});
        if (phone) {
          return (
            displayPhoneNumber(phone.areaCd, phone.phoneNumber) +
            (phone.phoneExt !== '' ? ' ext. ' + phone.phoneExt : '')
          );
        }
      }
    }
  };

  includesLastAOR = (user, lastAORs) => {
    if (lastAORs !== [{}]) {
      return false;
    }
    return !_.includes(Object.values(lastAORs), user);
  };

  fetchAllLastAOR = (users, entities) => {
    let count = [];
    let lastAOR = {};

    if (!_.isEmpty(users)) {
      _.forEach(entities, (entity) => {
        _.forEach(users, (user) => {
          if (user.entity.displayName === entity.displayName) {
            if (_.find(user.roles, {roleId: 1})) {
              lastAOR[entity.displayName] = user;
              if (count[entity.displayName] !== undefined) {
                count[entity.displayName]++;
                if (count[entity.displayName] === 2) {
                  lastAOR[entity.displayName] = {};
                  return false;
                }
              } else {
                count[entity.displayName] = 1;
              }
            }
          }
        });
      });
    }
    return lastAOR;
  };

  isLoggedInAOR = (user) => {
    if (user.userId === this.props.userId) {
      if (_.find(user.roles, {roleId: 1})) {
        return true;
      }
    }
    return false;
  };

  renderTeamMemberListing(ROLES, users, lastAORs, selectedUser, toggles) {
    return (
      <React.Fragment>
        {!this.props.loading ? (
          <React.Fragment>
            <p />
            {users && users.length > 0 ? (
              <FemaGoTable type="static">
                <FemaGoTable.Header>
                  <FemaGoTable.Row>
                    <FemaGoTable.HeaderCell>Name</FemaGoTable.HeaderCell>
                    {!_.includes(toggles, 'manageTeamOrgSubOrg') ? (
                      <FemaGoTable.HeaderCell>Roles</FemaGoTable.HeaderCell>
                    ) : (
                      <FemaGoTable.HeaderCell>
                        Roles and grant programs
                      </FemaGoTable.HeaderCell>
                    )}
                    <FemaGoTable.HeaderCell>Phone</FemaGoTable.HeaderCell>
                    {_.includes(toggles, 'loginGovIntegration') ? (
                      <FemaGoTable.HeaderCell>Email for notifications</FemaGoTable.HeaderCell>
                    ) : (
                      <FemaGoTable.HeaderCell>Email</FemaGoTable.HeaderCell>
                    )}
                    <FemaGoTable.HeaderCell>Actions</FemaGoTable.HeaderCell>
                  </FemaGoTable.Row>
                </FemaGoTable.Header>
                <FemaGoTable.Body divided="true">
                  {users.map((user) => {
                    const hasUnrestrictedRole = _.reduce(
                      user.roles,
                      (condition, role) =>
                        condition || (role.programs && role.programs.length === 0),
                      false
                    );
                    var groupedRoles = _.chain(user.roles).groupBy('roleId').value();
                    let length = _.chain(user.roles)
                      .map((role) =>
                        _.map(role.programs, (program) => {
                          program.programId;
                        })
                      )
                      .flatMap()
                      .value().length;
                    return (
                      <React.Fragment key={user.userId}>
                        <FemaGoTable.Row>
                          <FemaGoTable.TextCell>
                            <strong>
                              {(user.firstName ? user.firstName : '') +
                                ' ' +
                                (user.lastName ? user.lastName : '')}
                            </strong>
                          </FemaGoTable.TextCell>
                          {_.includes(toggles, 'manageTeamOrgSubOrg') ? (
                            <FemaGoTable.TextCell>
                              <strong>
                                {_.size(groupedRoles) > 1
                                  ? _.size(groupedRoles) + ' Roles, '
                                  : user.roles[0].description + ', '}
                              </strong>
                              {hasUnrestrictedRole
                                ? 'All Programs'
                                : length !== 0
                                ? length == 1
                                  ? length + ' ' + 'Program'
                                  : length + ' ' + 'Programs'
                                : 'All programs'}
                            </FemaGoTable.TextCell>
                          ) : (
                            <FemaGoTable.TextCell>
                              <strong>
                                {user.roles.length > 1
                                  ? user.roles.length + ' Roles, '
                                  : user.roles[0].description + ', '}
                              </strong>
                            </FemaGoTable.TextCell>
                          )}

                          <FemaGoTable.TextCell>
                            {this.prioritizePhoneList(user)}
                          </FemaGoTable.TextCell>
                          <FemaGoTable.TextCell>{user.emailAdr}</FemaGoTable.TextCell>
                          <FemaGoTable.TextCell>
                            {/* adding here to cover test but will need to implement this logic in the manage popup in story GMMGO-4203 */}
                            {this.includesLastAOR(user, lastAORs)}
                            {this.isLoggedInAOR(user)}
                            <a
                              LinkTo=""
                              title={`${user.userId} Manage User for Organization`}
                              onClick={(e) => {
                                e.preventDefault();
                                this.props.openManageTeamModal(user);
                              }}
                            >
                              <Icon name="user" />
                              Manage
                            </a>
                          </FemaGoTable.TextCell>
                        </FemaGoTable.Row>
                      </React.Fragment>
                    );
                  })}
                </FemaGoTable.Body>
              </FemaGoTable>
            ) : (
              <Alert header="No users available" type="info">
                <p>There are no users found with your search criteria.</p>
              </Alert>
            )}
          </React.Fragment>
        ) : (
          <Loader active>Loading...</Loader>
        )}
      </React.Fragment>
    );
  }

  renderPendingTeamMemberListing(ROLES, users, selectedUser) {
    const {renderType, subOrgToggle} = this.props;
    const roleDescriptions = [];
    const userRoleDescriptions = [];
    {
      selectedUser &&
        selectedUser.roles &&
        _.forEach(selectedUser.roles, (roles) => {
          roleDescriptions.push(roles.description);
        });
    }
    return (
      <React.Fragment>
        {!this.props.loading ? (
          <React.Fragment>
            <FemaGoModal
              title={`Remove unregistered user`}
              size="medium"
              closeOnDimmerClick="no"
              open={this.props.removeModalVisible}
              buttonText="Yes, remove unregistered user"
              confirmAction={() => this.handleRemoveClick(selectedUser)}
              cancelAction={() => this.props.toggleModal('remove')}
            >
              <Alert
                size="medium"
                header={'Are you sure you want to remove this unregistered user?'}
                paragraph={false}
                type="info"
                confirmButton="hidden"
              >
                <div id="team-notification">
                  <h5>{selectedUser && selectedUser.userId}</h5>
                  {_.map(selectedUser.roles, (role, index) => {
                    return (
                      <div className="roles-info" key={index}>
                        <small>
                          <strong>{`Role ${index + 1}`}</strong>
                        </small>
                        <p>{role.displayText}</p>
                      </div>
                    );
                  })}
                </div>
              </Alert>
            </FemaGoModal>
            <p />
            <FemaGoTable type="static">
              <FemaGoTable.Header>
                <FemaGoTable.Row>
                  <FemaGoTable.HeaderCell>Email</FemaGoTable.HeaderCell>
                  {((renderType == 'subOrg' || renderType == 'org') && subOrgToggle && (
                    <FemaGoTable.HeaderCell>
                      Roles and grant programs
                    </FemaGoTable.HeaderCell>
                  )) || <FemaGoTable.HeaderCell>Roles</FemaGoTable.HeaderCell>}
                  <FemaGoTable.HeaderCell>Actions</FemaGoTable.HeaderCell>
                </FemaGoTable.Row>
              </FemaGoTable.Header>
              <FemaGoTable.Body divided="true">
                {users.map((user) => {
                  const hasUnrestrictedRole = _.reduce(
                    user.roles,
                    (condition, role) =>
                      condition || (role.programs && role.programs.length === 0),
                    false
                  );
                  _.forEach(user.roles, (roles) => {
                    userRoleDescriptions.push(roles.description);
                  });

                  var groupedRoles = _.chain(user.roles).groupBy('roleId').value();

                  const programCount = _.chain(user.roles)
                    .map((role) => _.map(role.programs, (program) => program.programId))
                    .flatMap()
                    .value().length;

                  return (
                    <FemaGoTable.Row key={user.userId}>
                      <FemaGoTable.TextCell>{user.userId}</FemaGoTable.TextCell>
                      {(renderType == 'subOrg' || renderType == 'org') && subOrgToggle ? (
                        <FemaGoTable.TextCell>
                          <strong>
                            {_.size(groupedRoles) > 1
                              ? _.size(groupedRoles) + ' Roles, '
                              : user.roles[0].description + ', '}
                          </strong>
                          {hasUnrestrictedRole
                            ? 'All Programs'
                            : (programCount === 1 &&
                                user.roles.length === 1 &&
                                user.roles[0].programs[0].programName) ||
                              programCount === 0
                            ? 'All Programs'
                            : programCount + ' Programs'}
                        </FemaGoTable.TextCell>
                      ) : (
                        <FemaGoTable.TextCell>
                          <strong>
                            {user.roles.length > 1
                              ? user.roles.length + ' Roles'
                              : user.roles[0].description}
                          </strong>
                        </FemaGoTable.TextCell>
                      )}
                      <FemaGoTable.TextCell>
                        <Icon name="close" color="blue" />

                        <Link
                          title={`${user.userId} Remove unregistered user`}
                          to=""
                          text="Delete"
                          name={`role ${userRoleDescriptions.join(', ')} from ${
                            user.userId
                          } in ${user.entity.displayName}`}
                          onClick={(e, data) => {
                            e.preventDefault();
                            this.props.openRemoveModal(user);
                          }}
                          handleBlur={() => {}}
                        >
                          Remove unregistered user
                        </Link>
                      </FemaGoTable.TextCell>
                    </FemaGoTable.Row>
                  );
                })}
              </FemaGoTable.Body>
            </FemaGoTable>
          </React.Fragment>
        ) : (
          <Loader active>Loading...</Loader>
        )}
      </React.Fragment>
    );
  }

  render() {
    const {
      permissions,
      renderType,
      subOrgToggle,
      displayNameParent,
      parentOrgs,
      parentOrgId,
      orgs,
    } = this.props;
    const orgTeamRoles = orgRoles(permissions, renderType, subOrgToggle);

    const orgTeamLabel = renderType === 'org' ? 'Manage my team' : 'Manage user access';
    const orgTeamButtonLabel =
      renderType === 'org' ? 'Add new team member' : 'Add a new user';
    return (
      <React.Fragment>
        {!this.props.loading ? (
          <React.Fragment>
            <FemaGoModal
              title=""
              size="medium"
              open={this.props.showRolesModalVisible}
              confirmButton="hidden"
              cancelAction={() => this.props.toggleModal('showRoles')}
            >
              {createRolePermissionsBox(orgTeamRoles, subOrgToggle)}
            </FemaGoModal>

            <Grid verticalAlign="bottom">
              <Grid.Row>
                <Grid.Column width={8}>
                  <Header as="h3">
                    {this.props.pending ? 'Manage pending registrations' : orgTeamLabel}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3} textAlign="right">
                  <a
                    data-content="Roles and Perms"
                    color="blue"
                    className="rolesAndPermissions"
                    style={{fontSize: '12px'}}
                    onClick={() => this.props.toggleModal('showRoles')}
                    href="javascript:void(0);"
                  >
                    <Popup
                      hideOnScroll
                      position="top right"
                      wide="very"
                      content={createRolePermissionsBox(orgTeamRoles, subOrgToggle)}
                      trigger={
                        <div>
                          <Icon
                            name="info circle"
                            color="blue"
                            label="Roles & permissions"
                            title="Roles & permissions"
                          />
                          <strong label="Roles & permissions">
                            {'Roles & permissions'}
                          </strong>
                        </div>
                      }
                    />
                  </a>
                </Grid.Column>
                <Grid.Column width={5} textAlign="right">
                  <Button
                    size="medium"
                    rounded="true"
                    content={orgTeamButtonLabel}
                    primary
                    onClick={() => this.props.toggleModal('add')}
                    title="Add new team member"
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            {this.props.pending
              ? this.renderPendingTeamMemberListing(
                  orgTeamRoles,
                  this.state.users,
                  this.props.selectedUser
                )
              : this.renderTeamMemberListing(
                  orgTeamRoles,
                  this.state.users,
                  this.state.lastAORs,
                  this.props.selectedUser,
                  this.props.toggles
                )}
            <OrgUserManageForm
              loading={this.props.loading}
              selectedUser={this.props.selectedUser}
              manageModalVisible={this.props.manageModalVisible}
              openManageTeamModal={this.props.openManageTeamModal}
              closeManageTeamModal={this.props.closeManageTeamModal}
              selectedOrgId={this.props.selectedOrgId}
              prioritizePhoneList={this.prioritizePhoneList}
              toggleModal={this.props.toggleModal}
              reloadUserList={this.props.reloadUserList}
              isLoggedInAOR={this.isLoggedInAOR}
              stateUser={this.props.userData}
              programs={this.props.programs}
              assignedPrograms={this.props.assignedPrograms}
              subOrgToggle={this.props.subOrgToggle}
              renderType={this.props.renderType}
              toggles={this.props.toggles}
              displayNameParent={displayNameParent}
              parentOrgs={parentOrgs}
              parentOrgId={parentOrgId}
              orgs={orgs}
            />
            {this.renderRemoveConfirmation(this.props.selectedUser.userId)}
          </React.Fragment>
        ) : (
          <Loader active>Loading...</Loader>
        )}
      </React.Fragment>
    );
  }
}
export const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.auth.permissions,
    userId: state.auth.userId,
    toggles: state.toggles.toggles,
  };
};

export const connector = connect(mapStateToProps, null);
export default connector(orgUsersCard);
